module.exports = "/packs/images/navigation/juul-pods-27361fd2562bc04f9c00aceb2db268f2.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/navigation/juul-pods.png
// module id = 1819
// module chunks = 0